import { render, staticRenderFns } from "./PendenciaDlg.vue?vue&type=template&id=20d7fc36"
import script from "./PendenciaDlg.vue?vue&type=script&lang=js"
export * from "./PendenciaDlg.vue?vue&type=script&lang=js"
import style0 from "./PendenciaDlg.vue?vue&type=style&index=0&id=20d7fc36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports